import { doc, getFirestore, deleteDoc } from 'firebase/firestore';

const deleteCustomer = async (customerId: any) => {
  const db = getFirestore();
  const customerRef = doc(db, 'customers', customerId);
  deleteDoc(customerRef);
};

export default deleteCustomer;
